import VPagination from './VPagination';

VPagination.install = function install(Vue) {
  Vue.component(VPagination.name, VPagination);
};

export default VPagination;


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VPagination/index.js
// module id = 8Vjh
// module chunks = 0